import React, { useCallback, useState } from "react";
import { Box, Grid, Button, Dialog, Tabs, Tab } from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
// import VisibilityIcon from "@mui/icons-material/Visibility";
import AddEmployee from "../Employee/AddEmployee";
import {
  deleteEmployee,
  getUser,
  updateEmployee,
} from "../../services/user.service";
import AddUser from "../User/AddUser";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { ToastError, ToastSuccess } from "../../utils/Toaster/Toaster";
import MasterCommonTable from "../../sharedComponents/MaterCommonTable/MasterCommonTable";
import { useNavigate } from "react-router-dom";
import { debounce } from "../../utils/debounce";
import { encryptData } from "../../utils/cryptoUtils";
import PermissionGate from "../../components/Permission/PermissionGate";
import { usePermissions } from "../../context/PermissionProvider";

const Employee = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openEmployeeDrawer, setOpenEmployeeDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [tableTotalCount, setTableTotalCount] = useState(0);
  const [data, setData] = useState([]);
  const [queryParam, setQueryParam] = useState({
    search: "",
    page: 1,
    limit: 10,
  });
  const [currentTab, setCurrentTab] = useState(0); // 0 = Active, 1 = Inactive
  const THEME_COLOR = "#008080";

  const navigate = useNavigate();
  const { canAdd, canEdit, canDelete } = usePermissions();

  const getData = async () => {
    try {
      const payload = {
        isManager: encryptData(false),
        search: encryptData(queryParam.search || ""),
        page: encryptData(queryParam.page || 1),
        limit: encryptData(queryParam.limit || 10),
        isEnabled: currentTab === 0, // Filter by Active (true) or Inactive (false)
      };
      console.log("Payload:", payload); // Debugging log
      const res = await getUser(payload);
      const modifiedData =
        res?.data.data.map((e) => ({
          ...e,
        })) || [];
      setData(modifiedData);
      setTableTotalCount(res?.data?.totalCount || 0);
    } catch (error) {
      ToastError(error.data.message);
      console.log(error, "DATAERROR");
    }
  };

  React.useEffect(() => {
    getData();
  }, [queryParam.search, queryParam.page, queryParam.limit, queryParam.sort, currentTab]);

  const handleAdd = () => {
    setOpenDrawer(true);
    setSelectedData({});
  };

  const handleView = (e) => {
    e.isView = true;
    navigate(`/home/employeeDetails?id=${e._id}`);
    // setOpenEmployeeDrawer(true);
    setSelectedData(e);
  };

  const handleEdit = (e) => {
    e.isView = false;
    setSelectedData(e);
    navigate("/home/editEmployee", {
      state: { selectedData: e, formType: "edit" },
    });
  };

  const handleDelete = async (e) => {
    try {
      const res = await deleteEmployee(e._id);
      ToastError(res.message);
      getData();
    } catch (error) {
      console.log(error);
    }
  };
  const handleToggle = async (e) => {
    console.log(e, "EEEEEE");
    try {
      const formData = new FormData();
      const payload = {
        isEnabled: !e.isEnabled,
      };

      formData.append("bodyData", JSON.stringify(payload));

      const res = await updateEmployee(e._id, formData);
      if (payload.isEnabled) {
        ToastSuccess("Activated");
      } else {
        ToastError("Deactivated");
      }

      // Refresh data to reflect changes immediately, especially if it moves to the other tab
      getData();

    } catch (error) {
      ToastError(error?.data?.message);
    }
  };

  const debouncedHandleSearch = useCallback(
    debounce((searchText) => {
      setQueryParam((queryParams) => ({
        ...queryParams,
        search: searchText,
      }));
    }, 300),
    []
  );

  const handleSearch = (searchText) => {
    debouncedHandleSearch(searchText);
  };

  const columns = [
    { id: "employeeID", label: "Emp ID" },
    { id: "name", label: "Name" },
    { id: "email", label: "Email" },
    { id: "mobileNo", label: "Mobile No" },
    { id: "shiftName", label: "Shift" },
  ];

  const tableConfig = {
    isMore: true,
    isAction: true,
    isView: true,
    isEdit: canEdit("employee"),
    isToggle: true,
    isDelete: canDelete("employee"),
    isAdmin: true,
  };

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
    setQueryParam((prev) => ({ ...prev, page: 1 })); // Reset page on tab change
  };

  return (
    <div className="mainPageRenderingContainer">
      <Box sx={{ height: "fit-content" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
          <Tabs
            value={currentTab}
            onChange={handleTabChange}
            sx={{
              "& .MuiTab-root": {
                textTransform: "none",
                fontSize: "14px",
                fontWeight: 500,
                color: "#666",
              },
              "& .Mui-selected": {
                color: `${THEME_COLOR} !important`,
              },
              "& .MuiTabs-indicator": {
                backgroundColor: THEME_COLOR,
              },
            }}
          >
            <Tab label="Active Users" />
            <Tab label="Inactive Users" />
          </Tabs>
        </Box>
        <Grid container spacing={2} sx={{ justifyContent: "space-between" }}>
          <Grid item xs={12} sm={2.5}>
            <Box className="SearchInputBoxContainer">
              <SearchOutlinedIcon className="Search_Icon" />
              <input
                className="SearchInputBox"
                placeholder="Search here"
                onChange={(e) => handleSearch(e.target.value)}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6.5} />
          <Grid item xs={6} sm={2}>
            <PermissionGate module="employee" action="add">
              <Button
                startIcon={<AddOutlinedIcon />}
                onClick={() => handleAdd()}
                className="Add-Button w-100"
              >
                Add Employee
              </Button>
            </PermissionGate>
          </Grid>
        </Grid>
      </Box>
      <MasterCommonTable
        tableConfig={tableConfig}
        data={data}
        columns={columns}
        handleView={handleView}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        handleToggle={handleToggle}
        tableTotalCount={tableTotalCount}
      />
      <Dialog
        open={openDrawer}
        PaperProps={{
          style: {
            width: "100%",
            height: "fit-content",
          },
        }}
        fullWidth
        maxWidth="md"
      >
        {openDrawer ? (
          <AddUser
            selectedData={selectedData}
            setOpenDrawer={setOpenDrawer}
            formType={
              selectedData.isView ? "view" : selectedData._id ? "edit" : "add"
            }
            GetData={getData}
          />
        ) : null}
      </Dialog>
      <Dialog
        open={openEmployeeDrawer}
        PaperProps={{
          style: {
            width: "100%",
            height: "fit-content",
          },
        }}
        fullWidth
        maxWidth="md"
      >
        {openEmployeeDrawer ? (
          <AddEmployee
            selectedData={selectedData}
            setOpenDrawer={setOpenEmployeeDrawer}
            formType={
              selectedData.isView ? "view" : selectedData._id ? "edit" : "add"
            }
            GetData={getData}
          />
        ) : null}
      </Dialog>
    </div>
  );
};

export default Employee;
